/* sticky-atc.js — Dawn-compatible, multi-section safe */
(() => {
  if (window.__stickyATCInit) return; // guard from double load
  window.__stickyATCInit = true;

  const parseQty = (v) => {
    const n = parseInt(String(v).replace(/[^\d]/g, ''), 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };

  const getPF = (sticky, sectionId) => {
    const scope =
      document.getElementById(`ProductInfo-${sectionId}`) ||
      sticky.closest(`[id*="${sectionId}"]`) ||
      document;

    const productFormEl = scope.querySelector('product-form'); // web component
    const form          = productFormEl?.querySelector('form');
    const submitter     = productFormEl?.querySelector('button[name="add"], button[type="submit"]');
    const mainQty       = productFormEl?.querySelector('input[name="quantity"], .quantity__input[name="quantity"]');

    return { scope, productFormEl, form, submitter, mainQty };
  };

  const getFormQtyInputs = (sticky, sectionId) => {
    const { productFormEl, form } = getPF(sticky, sectionId);
    if (!form) return [];
    const set = new Set();
    productFormEl?.querySelectorAll('input[name="quantity"], .quantity__input[name="quantity"]').forEach(i => set.add(i));
    form.querySelectorAll('input[name="quantity"], .quantity__input[name="quantity"]').forEach(i => set.add(i));
    if (form.id) {
      document.querySelectorAll(`input[name="quantity"][form="${form.id}"], .quantity__input[name="quantity"][form="${form.id}"]`)
        .forEach(i => set.add(i));
    }
    return Array.from(set);
  };

  const writeFormQty = (sticky, sectionId, qty) => {
    getFormQtyInputs(sticky, sectionId).forEach(inp => {
      inp.value = qty;
      inp.setAttribute('value', qty);
      inp.dispatchEvent(new Event('input',  { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const syncFromFormToSticky = (sticky, sectionId) => {
    const inputs = getFormQtyInputs(sticky, sectionId);
    const src = inputs.find(i => parseQty(i.value) > 0) || inputs[0];
    const q = parseQty(src?.value ?? 1);
    const stickyQty = sticky.querySelector('.sticky-atc__qty-input');
    if (stickyQty) stickyQty.value = q;
  };

  const initOne = (sticky) => {
    if (sticky.dataset.stickyBound === '1') return; // already initialized  
    sticky.dataset.stickyBound = '1';

    const sectionId    = sticky.dataset.sectionId;
    if (sticky.parentElement !== document.body) document.body.appendChild(sticky);

    const stickyQty    = sticky.querySelector('.sticky-atc__qty-input');
    const minus        = sticky.querySelector('[data-sticky-minus]');
    const plus         = sticky.querySelector('[data-sticky-plus]');
    const stickySubmit = sticky.querySelector('[data-sticky-submit]');

    // Init qty
    if (stickyQty && !stickyQty.value) stickyQty.value = 1;
    syncFromFormToSticky(sticky, sectionId);

    // Sticky → Form
    minus?.addEventListener('click', () => {
      const q = Math.max(1, parseQty(stickyQty.value) - 1);
      stickyQty.value = q;
      writeFormQty(sticky, sectionId, q);
    });
    plus?.addEventListener('click', () => {
      const q = parseQty(stickyQty.value) + 1;
      stickyQty.value = q;
      writeFormQty(sticky, sectionId, q);
    });
    stickyQty?.addEventListener('input', () => {
      const q = parseQty(stickyQty.value);
      stickyQty.value = q;
      writeFormQty(sticky, sectionId, q);
    });

    // Form → Sticky 
    const { scope } = getPF(sticky, sectionId);
    const onFormQtyChange = (e) => {
      const t = e.target;
      if (!t) return;
      if (t.matches('input[name="quantity"], .quantity__input[name="quantity"]')) {
        syncFromFormToSticky(sticky, sectionId);
      }
    };
    scope?.addEventListener('input', onFormQtyChange);
    scope?.addEventListener('change', onFormQtyChange);

    // Submit — use original button <product-form> (slide cart)
    stickySubmit?.addEventListener('click', () => {
      const { form, submitter, mainQty } = getPF(sticky, sectionId);
      if (!form || !submitter) return;

      const q = parseQty(stickyQty.value);
      stickyQty.value = q;
      if (mainQty) {
        mainQty.value = q;
        mainQty.setAttribute('value', q);
        mainQty.dispatchEvent(new Event('input',  { bubbles: true }));
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      writeFormQty(sticky, sectionId, q);

      // Najvernije slide cart ponašanje:
      submitter.click();
      // If click ignored:
      // if (form.requestSubmit) form.requestSubmit(submitter);
    });

    // --- VIDLJIVOST: pokaži samo kada je originalno dugme skroz iznad ekrana,
    // sakrij ako je footer u vidokrugu ili ako je dugme ispod/vidljivo.
    // Dodaje/uklanja klasu na <body> dok je sticky vidljiv.
    const setupSmartVisibility = () => {
    const { submitter } = getPF(sticky, sectionId);
    if (!submitter) return;

    const footer = document.querySelector('.footer');

    const isAnyPartVisible = (el) => {
        if (!el) return false;
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        return r.top < vh && r.bottom > 0;
    };

    const show = () => {
        sticky.hidden = false;
        sticky.classList.add('is-visible');
        document.body.classList.add('has-sticky-atc'); // ⬅️ klasa na body
    };
    const hide = () => {
        sticky.classList.remove('is-visible');
        document.body.classList.remove('has-sticky-atc'); // ⬅️ ukloni sa body
        setTimeout(() => { if (!sticky.classList.contains('is-visible')) sticky.hidden = true; }, 220);
    };

    let ticking = false;
    const evaluate = () => {
        const r  = submitter.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;

        const buttonVisible = (r.top < vh && r.bottom > 0); // bilo koji deo u viewportu
        const buttonBelow   = (r.top >= vh);                 // ceo dugme ispod ekrana
        const buttonAbove   = (r.bottom <= 0);               // ceo dugme iznad ekrana
        const footerVisible = isAnyPartVisible(footer);

        // Prikaži SAMO ako je dugme potpuno iznad (prešli smo ga)
        // i footer NIJE u vidokrugu. U svim ostalim slučajevima sakrij.
        if (buttonAbove && !footerVisible) {
        show();
        } else {
        hide();
        }

        ticking = false;
    };

    const onScrollResize = () => {
        if (!ticking) {
        window.requestAnimationFrame(evaluate);
        ticking = true;
        }
    };

    // inicijalno i na promene
    evaluate();
    window.addEventListener('scroll', onScrollResize, { passive: true });
    window.addEventListener('resize', onScrollResize);

    // ako se menja layout/visine (varijante, lazy slika, itd.), reevaluiraj
    const mo = new MutationObserver(onScrollResize);
    mo.observe(document.body, { subtree: true, childList: true, attributes: false });
    const ro = new ResizeObserver(onScrollResize);
    ro.observe(sticky);
    };
    setupSmartVisibility();

  };

  const initAll = () => {
    document.querySelectorAll('.sticky-atc[data-section-id]').forEach(initOne);
  };

  // Init on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor (dinamičko učitavanje sekcija/blokova)
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
